export enum TimeTrackingState {
  SAVE_TIME = 'save-time',
  KEEP_TRACKING = 'keep-tracking',
  DISCARD = 'discard',
  NOACTION = 'noaction',
}
